export const setHeaderColour = (container) => {
	document.body.setAttribute('data-invert-header', container.dataset.invertHeader)
}

export default () => {} 